import { ApplicationRef, ComponentFactoryResolver, Injector, NgZone, Renderer2 } from "@angular/core";
import { Observable } from "rxjs";
import {
    ToastrService, GlobalConfig,
    ToastContainerDirective,
    ToastNoAnimation
} from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { Component, OnInit, Input } from '@angular/core';
import { cloneDeep, random } from 'lodash';
import { socialMediaToastrComponent } from "../socialMediaToastr/socialMediaToastr.component";

interface Quote {
    title?: string;
    message?: string;
}

const quotes: Quote[] = [
    {
        title: 'Title',
        message: 'Message',
    },
    {
        title: '😃',
        message: 'Supports Emoji',
    },
    {
        message: 'My name is Inigo Montoya. You killed my father. Prepare to die!',
    },
    {
        message: 'Titles are not always needed',
    },
    {
        title: 'Title only 👊',
    }
];

export class ToastrHelper {
    options: GlobalConfig;
    title = '';
    message = '';

    private lastInserted: number[] = [];

    constructor(public toastr: ToastrService) {
        this.options = this.toastr.toastrConfig;
    }


    private static toastr: ToastrService

    showSuccess(titl: string | undefined, msg: string | undefined, permanent: boolean) {

        const opt = this.options;
        opt.toastComponent = socialMediaToastrComponent;
        opt.toastClass = 'pinktoast';
        opt.disableTimeOut = true;
        opt.closeButton = true;
        opt.enableHtml = true;
        const { message, title } = this.getMessage();
        const inserted = this.toastr.show(msg || message, titl || title, opt);
        if (inserted && inserted.toastId) {
            this.lastInserted.push(inserted.toastId);
        }
        return inserted;

    }

    getMessage() {
        let m: string | undefined = this.message;
        let t: string | undefined = this.title;
        if (!this.title.length && !this.message.length) {
            const randomMessage = quotes[random(0, quotes.length - 1)];
            m = randomMessage.message;
            t = randomMessage.title;
        }
        return {
            message: m,
            title: t,
        };
    }



    FacebookSocialClik() {
        alert("Facebook");
    }
}

